import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";
import { certificates } from "../data/certifications";
import CertificationCard from "./CertificationCard";

const Certifications: React.FC = () => {
  return (
    <section id="certifications" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          Certifications
        </motion.h2>
        <div className="mt-6 grid md:grid-cols-2 gap-6">
          {certificates.map((c, i) => (
            <CertificationCard certification={c} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Certifications;
